<template>
  <div id="hero" class>
    <div class="hero_img">
      <div class="panel">
        <div class="d-flex justify-content-center">
          <div class="hero__text">
            <div class="title">APIS Systems Developers</div>
            <div class="subtitulo">
              Desarrollamos sistemas Web y aplicaciones móviles a la medida de
              las necesidades de nuestros clientes.
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {};
</script>
<style scoped>
#hero {
  background-color: #ebf5ee;
  align-items: center;
}
.hero_img {
  height: 400px;
  background-image: url("../assets/hero_web.jpg");
  background-repeat: no-repeat;
  background-position: bottom;
  background-size: cover;
}
.panel {
  background-color: rgba(0, 0, 0, 0.65);
  height: 100%;
  width: 100%;
  color: white;
}
.hero__text {
  margin: 0 20px;
  justify-content: initial;
}
.title {
  margin-top: 60px;
  font-size: 36px;
}
.subtitulo {
  margin-top: 30px;
  font-size: 22px;
}
@media screen and (min-width: 768px) {
  .title {
    margin-top: 100px;
    font-weight: bold;
  }
  .subtitulo {
    margin-top: 80px;
  }
}
@media screen and (min-width: 1024px) {
  .title {
    margin-top: 80px;
  }
  .subtitulo {
    margin-top: 120px;
  }
  .hero__text {
    max-width: 800px;
    margin-left: 50px;
    justify-content: initial;
  }
}
</style>
